// utils/construct-routing-object.ts
import { NO_CHANGE } from "../no-change.js";
var getRoutingInfoObject = (target, currentLocation) => {
  if (typeof target === "string") {
    const urlObject = new URL(target, currentLocation.origin);
    const path = urlObject.pathname;
    const hash = urlObject.hash ? urlObject.hash.substring(1) : "";
    const searchParams = urlObject.search ? urlObject.search.substring(1) : "";
    return { path, searchParams, hash, origin: urlObject.origin };
  } else {
    return target;
  }
};
var createRoutingObject = (targetURL, routingOptions = {}, currentLocation) => {
  const target = routingOptions.target || "_self";
  const routingInfo = getRoutingInfoObject(targetURL, currentLocation);
  if (target !== "_self" && routingInfo.path === NO_CHANGE)
    throw new Error("Cannot use path:NO_CHANGE for targets other than _self");
  const searchParams = routingInfo.searchParams ? routingInfo.searchParams === NO_CHANGE ? currentLocation.search ? new URLSearchParams(currentLocation.search) : void 0 : new URLSearchParams(routingInfo.searchParams) : void 0;
  const hash = routingInfo.hash ? routingInfo.hash === NO_CHANGE ? currentLocation.hash ? currentLocation.hash : "" : routingInfo.hash : "";
  const pathname = routingInfo.path ? routingInfo.path === NO_CHANGE ? currentLocation.pathname ? currentLocation.pathname : "/" : routingInfo.path : "";
  const origin = routingInfo.origin ? routingInfo.origin : currentLocation.origin;
  const spa = target === "_self" && origin === currentLocation.origin;
  const replaceState = routingOptions.replaceState ?? false;
  return {
    origin,
    pathname,
    searchParams,
    hash,
    target,
    spa,
    replaceState,
    openFeatures: routingOptions.openFeatures,
    inAppBrowserOptions: routingOptions.inAppBrowserOptions
  };
};
export {
  createRoutingObject
};
